import '../scss/main.scss';
import { Navbar } from './modules';
import { CssVariables } from './Setup/CssVariables';

if (document.querySelector('[data-navbar]')) {
  new Navbar();
}

//TODO: remove this after migration to v2
// if (document.querySelector('[data-toggle-modal="modal-sign-up"]')) {
//   (async () => {
//     const { SignInCourseModal } = await import('./CourseModule/Components');
//     new SignInCourseModal();
//   })();
// }

// if (
//   document.querySelector('.cart-courses-wrapper')
//   && !document.querySelector('[data-upsell-quick-add-root]')
// ) {
//   (async () => {
//     const { UpsellingCourses } = await import('./CourseModule/Components');
//     new UpsellingCourses();
//   })();
// }

if (document.querySelector('.woocommerce-cart')) {
  (async () => {
    const { CartUpdated } = await import('./CourseModule/Events');
    new CartUpdated();
  })();
}

if (document.querySelector('[data-remove-item-url]')) {
  (async () => {
    const { initRemoveItemModal } = await import('./CourseModuleV2/main');
    initRemoveItemModal();
  })();
}

if (document.querySelector('.woocommerce-billing-fields')) {
  (async () => {
    const { CheckoutValidator } = await import('./CourseModule/Validators');
    new CheckoutValidator();
  })();
}

if (document.querySelector('[data-cart-widget]')) {
  (async () => {
    const { CartWidget } = await import('./CourseModule/Components/Cart/CartWidget');
    new CartWidget();
  })();
}

if (document.querySelector('[data-due-date-picker]')) {
  (async () => {
    const { initDueDateCoursePicker } = await import('./CourseModuleV2/DueDateCoursePicker');
    initDueDateCoursePicker();
  })();
}

if (document.querySelector('[data-schedule-table]')) {
  (async () => {
    const { ScheduleTableAvailablePlaces } = await import('./CourseModule/Components/Course/ScheduleTableAvailablePlaces');
    const { CourseElementsHandler } = await import('./modules/Gutenberg/CourseElementsHandler');
    const all = Array.from(document.querySelectorAll('[data-schedule-table]'));

    for (const el of all) {
      if (el.hasAttribute('data-due-date-picker-enabled')) continue;
      new ScheduleTableAvailablePlaces(el as HTMLElement);
      new CourseElementsHandler(el as HTMLElement);
    }
  })();
}

if (document.querySelector('[data-order-summary-table]')) {
  (async () => {
    const { OrderSummaryTable } = await import('./CourseModule/Components/Order/OrderSummaryTable');
    new OrderSummaryTable();
  })();
}

document.addEventListener('DOMContentLoaded', () => {
  CssVariables.init();
});

if(document.querySelector('a[href^="mailto:"], a[href^="tel:"], a[href^="https://wa.me/"]')) {
  (async () => {
    const { ContactIntent } = await import('./Analytics/ContactIntent');
    new ContactIntent();
  })()
}

if (document.querySelector('[data-modal-open]')) {
  (async () => {
    const { ModalHandler } = await import('./modules/Gutenberg/ModalHandler');
    new ModalHandler();
  })();
}

if (document.querySelector('[data-course-modal-trigger], [data-course-modal-service], [data-due-date-picker]')) {
  (async () => {
    const { initCourseCartModal } = await import('./CourseModuleV2/main');
    initCourseCartModal();
  })();
}

if (document.querySelector('[data-upsell-quick-add-root]')) {
  (async () => {
    const { initUpsellQuickAddApp } = await import('./CourseModuleV2/upsellQuickAddApp');
    initUpsellQuickAddApp();
  })();
}

if (document.querySelector('.single-product')) {
  (async () => {
    const { ProductPage } = await import('./WooCommerce/ProductPage');
    new ProductPage();
  })();
}